export default __webpack_public_path__ + "static/media/advantageIcon1.bbb469f9.webp";